import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgManageUsers = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6 6C6 4.86667 6.86667 4 8 4C9.13333 4 10 4.86667 10 6C10 7.13333 9.13333 8 8 8C6.86667 8 6 7.13333 6 6ZM8 9.33333C4.93333 9.33333 4 11.5333 4 11.5333V12.6667H12V11.5333C12 11.5333 11.0667 9.33333 8 9.33333Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3307 7.33333C13.2512 7.33333 13.9974 6.58714 13.9974 5.66667C13.9974 4.74619 13.2512 4 12.3307 4C11.4103 4 10.6641 4.74619 10.6641 5.66667C10.6641 6.58714 11.4103 7.33333 12.3307 7.33333Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3315 8.66797C11.5315 8.66797 10.9315 8.86797 10.4648 9.2013C11.9982 9.93464 12.5982 11.2013 12.5982 11.3346V11.4013H15.3315V10.5346C15.3315 10.468 14.5982 8.66797 12.3315 8.66797Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3307 7.33333C13.2512 7.33333 13.9974 6.58714 13.9974 5.66667C13.9974 4.74619 13.2512 4 12.3307 4C11.4103 4 10.6641 4.74619 10.6641 5.66667C10.6641 6.58714 11.4103 7.33333 12.3307 7.33333Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3315 8.66797C11.5315 8.66797 10.9315 8.86797 10.4648 9.2013C11.9982 9.93464 12.5982 11.2013 12.5982 11.3346V11.4013H15.3315V10.5346C15.3315 10.468 14.5982 8.66797 12.3315 8.66797Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.66667 7.33333C4.58714 7.33333 5.33333 6.58714 5.33333 5.66667C5.33333 4.74619 4.58714 4 3.66667 4C2.74619 4 2 4.74619 2 5.66667C2 6.58714 2.74619 7.33333 3.66667 7.33333Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.66797 8.66797C4.46797 8.66797 5.06797 8.86797 5.53464 9.2013C4.0013 9.93464 3.4013 11.2013 3.4013 11.3346V11.4013H0.667969V10.5346C0.667969 10.468 1.4013 8.66797 3.66797 8.66797Z",
			fill: "currentColor"
		})
	]
});
export default SvgManageUsers;
